import axios from "axios";
import Enumerable from 'linq';
import paltform from './paltform.json'


export function goback() {
    window.history.go(-1)
}
export function getPlatform() {
    var info = getUserinfo();
    let platjson = Enumerable.from(paltform).firstOrDefault(w => w.id == info.plat);
    axios.defaults.headers["Accept-Language"] = platjson.language;
    return platjson;
}

export function getUserinfo() {
    var infostr = localStorage.getItem('ai-info');
    var info = JSON.parse(infostr);
    return info;
}

export function resize(imgurl, size) {
    if (imgurl.indexOf('aivideo.') > -1) {
        let resize_url = imgurl.replace('/api/file-store', "/images");
        if (size != null) {
            resize_url += "?" + size;
        } else {
            resize_url += "?size=0x100";
        }
        return resize_url;
    } else {
        return imgurl;
    }
}

export default { goback, getPlatform, getUserinfo, resize }